import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SignaturesService } from "../../signatures.service";
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
  ValidatorFn,
} from "@angular/forms";
import {
  greaterThan,
  lowerThan,
  validateNotPastDate,
} from "../../../shared/validators/date.validator";
import { Observable } from "rxjs";
import { Template } from "../../signatures.interface";
import { ShowOnSubmitAttemptErrorStateMatcher } from "../../../shared/error-state-matcher";

@Component({
  selector: "app-wizard-final",
  templateUrl: "./wizard-final.component.html",
  styleUrls: ["./wizard-final.component.scss"],
  standalone: false,
})
export class WizardFinalComponent implements OnInit {
  form: UntypedFormGroup;
  errorStateMatcher = new ShowOnSubmitAttemptErrorStateMatcher();
  readonly footerLabel = (footer: Template) => footer.name || "";
  readonly footerValue = (footer: Template) => footer.templateId;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private service: SignaturesService,
  ) {
    const requiredValidator: ValidatorFn = Validators.required.bind(
      null,
    ) as ValidatorFn;
    const lowerThanValidator = lowerThan("dateTo");
    const greaterThanValidator = greaterThan("dateFrom");
    this.form = new UntypedFormGroup({
      dateFrom: new UntypedFormControl("", [
        requiredValidator,
        validateNotPastDate,
        lowerThanValidator,
      ]),
      tmplFrom: new UntypedFormControl("", requiredValidator),
      dateTo: new UntypedFormControl("", [
        requiredValidator,
        greaterThanValidator,
      ]),
      tmplTo: new UntypedFormControl("", requiredValidator),
    });
  }
  state: { internal?: unknown };
  footers: Observable<Template[]>;
  updating: boolean;
  minDate: { year: number; month: number; day: number };

  ngOnInit(): void {
    const date = new Date();
    this.minDate = {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDay(),
    };
    this.state = window.history.state as { internal?: unknown };

    if (!this.state.internal) {
      void this.router.navigate(["wizard"]);
    } else {
      this.footers = this.service.getAll();
    }
  }

  submit() {
    this.errorStateMatcher.submitAttempted = true;
    if (this.form.invalid || this.updating) {
      return;
    }
    this.updating = true;
    const formValue = this.form.value as {
      dateFrom: unknown;
      dateTo: unknown;
      tmplFrom: unknown;
      tmplTo: unknown;
    };
    const { dateFrom, dateTo, tmplFrom, tmplTo } = formValue;
    const dateFromMoment = dateFrom as {
      year: () => number;
      month: () => number;
      date: () => number;
    };
    const dateToMoment = dateTo as {
      year: () => number;
      month: () => number;
      date: () => number;
    };
    const fromUtc = Date.UTC(
      dateFromMoment.year(),
      dateFromMoment.month(),
      dateFromMoment.date(),
    );
    const toUtc = Date.UTC(
      dateToMoment.year(),
      dateToMoment.month(),
      dateToMoment.date(),
    );

    void this.service
      .setFooter({
        fromUtc,
        toUtc,
        tmplFrom,
        tmplTo,
        context: this.state.internal,
      })
      .toPromise()
      .then(() => this.router.navigate(["wizard/success"]))
      .finally(() => (this.updating = false));
  }
}
